// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footerContainer {
  display: flex;
  width: 100%;
  padding: 64px 200px 40px 200px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 64px;
  background: var(--Black, #101010);
}

.footerContainer.hidden {
  display: none !important;
}

.innerContainer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 200px;
}

.sponsorContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
}

.quicklinkContainer {
  display: flex;
  align-items: flex-start;
  gap: 64px;
}

.quickLinks {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
}

.img-quickLinks {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

.title {
  color: #717171;
  font-family: "General Sans";
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.48px;
  text-transform: uppercase;
  align-self: stretch;
}

.body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
}

.img-body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
}

.link {
  color: #FDFDFD;
  font-family: "General Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 125% */
  display: flex;
}

.copyrights {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
}

.divider {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border: 1px solid rgba(248, 248, 248, 0.0745098039);
}

.text {
  color: var(--Grey-70, #878787);
  text-align: center;
  font-family: "General Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  align-self: stretch;
}

@media screen and (max-width: 650px) {
  .footerContainer {
    display: flex;
    width: 100%;
    padding: 50px 24px 32px 28px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 48px;
  }
  .innerContainer {
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    align-items: flex-start;
    gap: 48px;
    align-self: stretch;
  }
  .sponsorContainer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 40px;
  }
  .quicklinkContainer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 40px;
    align-self: stretch;
  }
  .quickLinks {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
  }
  .img-quickLinks {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  .title {
    color: #717171;
    font-family: "General Sans";
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.48px;
    text-transform: uppercase;
    align-self: stretch;
  }
  .body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    align-self: stretch;
  }
  .img-body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
  }
  .link {
    color: #FDFDFD;
    font-family: "General Sans";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 125% */
  }
  .copyrights {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    align-self: stretch;
  }
  .divider {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    border: 1px solid rgba(248, 248, 248, 0.0745098039);
  }
  .text {
    color: var(--Grey-70, #878787);
    text-align: center;
    font-family: "General Sans";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    align-self: stretch;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/landing-page/components/footer/style.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,WAAA;EACA,8BAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,iCAAA;AACJ;;AAEA;EACI,wBAAA;AACJ;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,UAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AACJ;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,SAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AACJ;;AAEA;EACI,cAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;AACJ;;AAGA;EACI,cAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,aAAA;AAAJ;;AAGA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mDAAA;AAAJ;;AAGA;EACI,8BAAA;EACA,kBAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAAJ;;AAGA;EACI;IACI,aAAA;IACA,WAAA;IACA,4BAAA;IACA,sBAAA;IACA,uBAAA;IACA,mBAAA;IACA,SAAA;EAAN;EAGE;IACI,aAAA;IACA,8BAAA;IACA,uBAAA;IACA,uBAAA;IACA,SAAA;IACA,mBAAA;EADN;EAIE;IACI,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,SAAA;EAFN;EAKE;IACI,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,SAAA;IACA,mBAAA;EAHN;EAME;IACI,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,SAAA;EAJN;EAOE;IACI,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,SAAA;EALN;EAQE;IACI,cAAA;IACA,2BAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;IACA,sBAAA;IACA,yBAAA;IACA,mBAAA;EANN;EASE;IACI,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,SAAA;IACA,mBAAA;EAPN;EAUE;IACI,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,QAAA;IACA,mBAAA;EARN;EAYE;IACI,cAAA;IACA,2BAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA,EAAA,SAAA;EAVN;EAaE;IACI,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,SAAA;IACA,mBAAA;EAXN;EAcE;IACI,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,mBAAA;IACA,mDAAA;EAZN;EAeE;IACI,8BAAA;IACA,kBAAA;IACA,2BAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;IACA,mBAAA;EAbN;AACF","sourcesContent":[".footerContainer{\n    display: flex;\n    width: 100%;\n    padding: 64px 200px 40px 200px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 64px;\n    background: var(--Black, #101010);\n}\n\n.footerContainer.hidden {\n    display: none !important;\n}\n\n.innerContainer{\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    gap: 200px;\n}\n\n.sponsorContainer{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 40px;\n}\n\n.quicklinkContainer{\n    display: flex;\n    align-items: flex-start;\n    gap: 64px;\n}\n\n.quickLinks{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 24px;\n}\n\n.img-quickLinks{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n}\n\n.title{\n    color: #717171;\n    font-family: \"General Sans\";\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: 0.48px;\n    text-transform: uppercase;\n    align-self: stretch;\n}\n\n.body{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 20px;\n    align-self: stretch;\n}\n\n.img-body{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    align-self: stretch;\n}\n\n\n.link{\n    color: #FDFDFD;\n    font-family: \"General Sans\";\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px; /* 125% */\n    display: flex;\n}\n\n.copyrights{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 24px;\n    align-self: stretch;\n}\n\n.divider{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    align-self: stretch;\n    border: 1px solid #f8f8f813;\n}\n\n.text{\n    color: var(--Grey-70, #878787);\n    text-align: center;\n    font-family: \"General Sans\";\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n    align-self: stretch;\n}\n\n@media screen and (max-width: 650px) {\n    .footerContainer{\n        display: flex;\n        width: 100%;\n        padding: 50px 24px 32px 28px;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        gap: 48px;\n    }\n    \n    .innerContainer{\n        display: flex;\n        flex-direction: column-reverse;\n        justify-content: center;\n        align-items: flex-start;\n        gap: 48px;\n        align-self: stretch;\n    }\n    \n    .sponsorContainer{\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 40px;\n    }\n    \n    .quicklinkContainer{\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 40px;\n        align-self: stretch;\n    }\n    \n    .quickLinks{\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 24px;\n    }\n    \n    .img-quickLinks{\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 12px;\n    }\n    \n    .title{\n        color: #717171;\n        font-family: \"General Sans\";\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n        letter-spacing: 0.48px;\n        text-transform: uppercase;\n        align-self: stretch;\n    }\n    \n    .body{\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 20px;\n        align-self: stretch;\n    }\n    \n    .img-body{\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 8px;\n        align-self: stretch;\n    }\n    \n    \n    .link{\n        color: #FDFDFD;\n        font-family: \"General Sans\";\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 20px; /* 125% */\n    }\n    \n    .copyrights{\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 24px;\n        align-self: stretch;\n    }\n    \n    .divider{\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        align-self: stretch;\n        border: 1px solid #f8f8f813;\n    }\n    \n    .text{\n        color: var(--Grey-70, #878787);\n        text-align: center;\n        font-family: \"General Sans\";\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 20px;\n        align-self: stretch;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
